



















import Vue from 'vue';
export default Vue.extend({
  data: () => ({
    showHeader: true,
  }),
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    goBack() {
      // eslint-disable-next-line no-debugger
      // debugger;
      this.$router.back();
    },
  },
  watch: {
    $route() {
      this.showHeader = this.$route.path === '/auth/register';
    },
  },
  mounted() {
    this.showHeader = this.$route.path === '/auth/register';
  },
});
